import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Clock, AlertTriangle, FileText } from "lucide-react";

const validations = [
    {
        id: 1,
        type: "Validation Budgétaire - Expansion Usine Lyon",
        description: "Validation du dépassement budgétaire de 150K€ pour l'achat d'équipements supplémentaires",
        manager: "PD",
        managerName: "Philippe Durand",
        deadline: "22/06/2025",
        priority: "urgent"
    },
    {
        id: 2,
        type: "Validation Technique - Migration ERP",
        description: "Validation du plan de migration et des ressources techniques supplémentaires",
        manager: "ML",
        managerName: "Marie Lefèvre",
        deadline: "28/06/2025",
        priority: "important"
    },
    {
        id: 3,
        type: "Validation Stratégique - Flotte Véhicules Électriques",
        description: "Validation du plan de déploiement et des fournisseurs sélectionnés",
        manager: "TB",
        managerName: "Thomas Bertrand",
        deadline: "05/07/2025",
        priority: "normal"
    },
    {
        id: 4,
        type: "Validation ROI - Optimisation Énergétique",
        description: "Validation des calculs de retour sur investissement et des économies projetées",
        manager: "CD",
        managerName: "Claire Dubois",
        deadline: "12/07/2025",
        priority: "planifie"
    }];


const priorityColors: Record<string, string> = {
    "urgent": "bg-red-100 text-red-800 border-red-200",
    "important": "bg-yellow-100 text-yellow-800 border-yellow-200",
    "normal": "bg-blue-100 text-blue-800 border-blue-200",
    "planifie": "bg-green-100 text-green-800 border-green-200"
};

const priorityIcons: Record<string, any> = {
    "urgent": AlertTriangle,
    "important": Clock,
    "normal": FileText,
    "planifie": FileText
};

export default function ValidationQueue() {
    return (
        <Card className="border-0 shadow-lg">
            <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="text-lg font-bold text-gray-900">
                    Validations à Venir
                </CardTitle>
                <Button variant="link" className="text-teal-600">
                    Voir toutes les validations →
                </Button>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    {validations.map((validation) => {
                        const Icon = priorityIcons[validation.priority];
                        return (
                            <div key={validation.id} className="border border-gray-100 rounded-xl p-4 hover:bg-gray-50 transition-colors">
                                <div className="flex items-start justify-between">
                                    <div className="flex gap-3">
                                        <Badge className="bg-red-100 text-red-800 mx-auto px-2.5 py-0.5 text-xs font-semibold rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 border-red-200 border flex items-center gap-1 h-8">
                                            <Icon className="w-3 h-3" />
                                            {validation.priority === "urgent" ? "Urgent" :
                                                validation.priority === "important" ? "Important" :
                                                    validation.priority === "normal" ? "Normal" : "Planifié"}
                                        </Badge>
                                        <div className="flex-1">
                                            <h4 className="font-semibold text-gray-900 mb-1">{validation.type}</h4>
                                            <p className="text-sm text-gray-600 mb-3">{validation.description}</p>
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-2">
                                                    <Avatar className="w-6 h-6">
                                                        <AvatarFallback className="bg-teal-100 text-teal-700 text-xs">
                                                            {validation.manager}
                                                        </AvatarFallback>
                                                    </Avatar>
                                                    <span className="text-sm text-gray-700">{validation.managerName}</span>
                                                </div>
                                                <div className="flex items-center gap-2 text-sm text-gray-500">
                                                    <Clock className="w-4 h-4" />
                                                    Échéance: {validation.deadline}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>);

                    })}
                </div>
            </CardContent>
        </Card>);

}
